var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Box from "../box/Box";
import Text from "../text/Text";
export var MessageLevelEnum;
(function (MessageLevelEnum) {
    MessageLevelEnum["SUCCESS"] = "SUCCESS";
    MessageLevelEnum["ERROR"] = "ERROR";
    MessageLevelEnum["INFO"] = "INFO";
    MessageLevelEnum["WARNING"] = "WARNING";
})(MessageLevelEnum || (MessageLevelEnum = {}));
var levelsToColors = new Map([
    [MessageLevelEnum.SUCCESS, ["earthGreens.0", "earthGreens.6"]],
    [MessageLevelEnum.INFO, ["trainingBlues.0", "trainingBlues.6"]],
    [MessageLevelEnum.WARNING, ["hsl(45, 100%, 90%)", "hsl(45, 100%, 25%)"]],
    [MessageLevelEnum.ERROR, ["gameReds.0", "gameReds.6"]],
]);
var MessageBox = function (_a) {
    var message = _a.message, level = _a.level, children = _a.children, boxProps = __rest(_a, ["message", "level", "children"]);
    if (!message) {
        return null;
    }
    var colors = levelsToColors.get(level || MessageLevelEnum.INFO);
    if (!colors) {
        throw new Error("Colors are not defined for message level '".concat(level, "'."));
    }
    var backgroundColor = colors[0], textColor = colors[1];
    return (React.createElement(Box, __assign({ display: ["block", "flex"], justifyContent: "space-between", alignItems: "center", backgroundColor: backgroundColor, py: 3, px: 5, my: 3, role: "alert" }, boxProps),
        React.createElement(Text, { as: "p", color: textColor, flex: "1 1 auto" }, message),
        children && (React.createElement(Box, { mt: [3, 0], ml: [0, 3] }, children))));
};
export default MessageBox;
//# sourceMappingURL=MessageBox.js.map